import * as React from 'react';
import {createTheme, ThemeProvider, useColorScheme} from "@mui/material";
import {CssBaseline} from '@mui/material';

const muiTheme = createTheme({
    colorSchemes: {
        light: {
            palette: {
                text: {
                    primary: '#384341',
                },
                "primary": {
                    "light": "#62727b",
                    "main": "#37474f",
                    "dark": "#102027",
                    "contrastText": "#ffffff"
                },
                "info": {
                    "main": "#0969da",
                },
                background: {
                    paper: "#f6f8fa",
                }
            }
        },
        dark: {
            palette: {
                text: {
                    primary: '#c7cfce',
                },
                primary: {
                    "main": "#7A7AFE",
                    "dark": "#6E6EE5",
                    "light": "#8787FE"
                },
                "info": {
                    "main": "#2f81f7"
                },
                background: {
                    paper: "#21262c",
                    default: '#0d1117'
                }
            },
        }
    },
    cssVariables: {
        colorSchemeSelector: 'class'
    },
})

// const ThemeSwitch = () => {
//     const {mode, setMode} = useColorScheme();
//
//     const isBrowser = typeof window !== 'undefined';
//
//     if (isBrowser) {
//         const colorMode = localStorage.getItem("chakra-ui-color-mode")
//
//         if (colorMode) {
//             if (colorMode === 'dark') {
//                 setMode('dark')
//             } else {
//                 setMode('light')
//             }
//         }
//     }
//
//     return <></>
// }
export const WrapRootElement = ({element}) => {


    return (
        <ThemeProvider theme={muiTheme}>
            <CssBaseline/>
            {/*<ThemeSwitch/>*/}
            <>{element}</>
        </ThemeProvider>
    );
};
